import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rgbatohex" }
const _hoisted_2 = { class: "rgbatohex__box rgbatohex__box--border" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Converted", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "Preview", -1)
const _hoisted_6 = { class: "rgbatohex__preview-container" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "rgbatohex__bg-container" }
const _hoisted_11 = { class: "rgbatohex__inner" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "rgbatohex__bg-container rgbatohex__bg-container--white" }
const _hoisted_14 = { class: "rgbatohex__inner" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "rgbatohex__box-item" }
const _hoisted_19 = { class: "rgbatohex__pre" }
const _hoisted_20 = { class: "rgbatohex__box-item" }
const _hoisted_21 = { class: "rgbatohex__pre" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ")
const _hoisted_24 = { class: "rgbatohex__box-item" }
const _hoisted_25 = { class: "rgbatohex__pre" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Div content here</div>\n")
const _hoisted_28 = { class: "rgbatohex__box-item" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("pre", { class: "rgbatohex__pre" }, [
  /*#__PURE__*/_createTextVNode("<div style=\"border:3px solid #45ca58\">"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Div here</div>\n")
], -1)
const _hoisted_30 = { class: "col-md-6" }
const _hoisted_31 = { class: "rgbatohex__box-item" }
const _hoisted_32 = { class: "rgbatohex__pre" }
const _hoisted_33 = { class: "rgbatohex__box-item" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("h4", null, "Text Shadow with RGB Values", -1)
const _hoisted_35 = { class: "rgbatohex__pre" }
const _hoisted_36 = { class: "rgbatohex__box-item" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h4", null, "Text Shadow with Hex Values", -1)
const _hoisted_38 = { class: "rgbatohex__pre" }
const _hoisted_39 = { class: "rgbatohex__box-item" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h4", null, "Div Box Shadow", -1)
const _hoisted_41 = { class: "rgbatohex__pre" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Div content here</div>\n")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RgbaToHex = _resolveComponent("RgbaToHex")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_RgbaToHex, { onColorRgba: _ctx.calcRgba }, null, 8, ["onColorRgba"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", null, _toDisplayString(_ctx.backgroundColor), 1),
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "rgbatohex__preview",
          style: _normalizeStyle({ 'background-color': _ctx.backgroundColor })
        }, _toDisplayString(_ctx.backgroundColor), 5)
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.backgroundColor) + " Color Preview on Black Background", 1),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: "rgbatohex__preview rgbatohex__preview--small",
                style: _normalizeStyle({ 'background-color': _ctx.backgroundColor })
              }, null, 4),
              _createElementVNode("p", {
                style: _normalizeStyle({ color: _ctx.backgroundColor })
              }, " Lorem ipsum dolor sit amet. ", 4)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.backgroundColor) + " Color Preview on White Background", 1),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", {
                class: "rgbatohex__preview rgbatohex__preview--small",
                style: _normalizeStyle({ 'background-color': _ctx.backgroundColor })
              }, null, 4),
              _createElementVNode("p", {
                style: _normalizeStyle({ color: _ctx.backgroundColor })
              }, " Lorem ipsum dolor sit amet. ", 4)
            ])
          ])
        ])
      ]),
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.backgroundColor) + " Color CSS Codes", 1),
            _createElementVNode("pre", _hoisted_19, ".mybgcolor {background-color:" + _toDisplayString(_ctx.backgroundColor) + "; }\n.myforecolor {color:" + _toDisplayString(_ctx.backgroundColor) + "; }\n.mybordercolor {border:3px solid " + _toDisplayString(_ctx.backgroundColor) + "; }\n", 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.backgroundColor) + " Text Font Color", 1),
            _createElementVNode("pre", _hoisted_21, "<p style=\"color:" + _toDisplayString(_ctx.backgroundColor) + "; }\">Text here</p>\n", 1),
            _createElementVNode("p", {
              style: _normalizeStyle({ color: _ctx.backgroundColor })
            }, [
              _createTextVNode(" This sample text font color is " + _toDisplayString(_ctx.backgroundColor), 1),
              _hoisted_22,
              _hoisted_23
            ], 4)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.backgroundColor) + " Background Color", 1),
            _createElementVNode("pre", _hoisted_25, [
              _createTextVNode("<div style=\"background-color:" + _toDisplayString(_ctx.backgroundColor) + "\">", 1),
              _hoisted_26,
              _hoisted_27
            ]),
            _createElementVNode("div", {
              class: "rgbatohex__box-block",
              style: _normalizeStyle({ background: _ctx.backgroundColor })
            }, " This div background color is " + _toDisplayString(_ctx.backgroundColor), 5)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.backgroundColor) + " Border Color", 1),
            _hoisted_29,
            _createElementVNode("div", {
              class: "rgbatohex__box-block rgbatohex__box-block--text",
              style: _normalizeStyle({ border: '3px solid ' + _ctx.backgroundColor })
            }, " This div background color is " + _toDisplayString(_ctx.backgroundColor), 5)
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.backgroundColor) + " Css3 Examples", 1),
            _createElementVNode("pre", _hoisted_32, ".textShadowRgb {\ntext-shadow: 4px 4px 2px " + _toDisplayString(_ctx.colorCalculated) + "; } \n.textShadowHex { \ntext-shadow: 4px 4px 2px " + _toDisplayString(_ctx.backgroundColor) + "; }\n.divShadow { \n-moz-box-shadow: 1px 1px 3px 2px " + _toDisplayString(_ctx.backgroundColor) + ";\n-webkit-box-shadow: 1px 1px 3px 2px " + _toDisplayString(_ctx.backgroundColor) + ";\nbox-shadow:         1px 1px 3px 2px " + _toDisplayString(_ctx.backgroundColor) + "; }\n", 1)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("pre", _hoisted_35, "<p style=\"text-shadow: 4px 4px 2px " + _toDisplayString(_ctx.colorCalculated) + ";\">Text here</p>\n", 1),
            _createElementVNode("p", {
              style: _normalizeStyle({ 'text-shadow': '4px 4px 2px ' + _ctx.colorCalculated })
            }, " This text has shadow with rgb values. ", 4)
          ]),
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("pre", _hoisted_38, "<p style=\"text-shadow: 4px 4px 2px #" + _toDisplayString(_ctx.hex) + "\">Text here</p>\n", 1),
            _createElementVNode("p", {
              style: _normalizeStyle({ 'text-shadow': '4px 4px 2px #' + _ctx.hex })
            }, " This text has shadow with rgb values. ", 4)
          ]),
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _createElementVNode("pre", _hoisted_41, [
              _createTextVNode("<div style=\"-moz-box-shadow: 1px 1px 3px 2px " + _toDisplayString(_ctx.backgroundColor) + ";\n-webkit-box-shadow: 1px 1px 3px 2px " + _toDisplayString(_ctx.backgroundColor) + ";\nbox-shadow:         1px 1px 3px 2px " + _toDisplayString(_ctx.backgroundColor) + ";\">", 1),
              _hoisted_42,
              _hoisted_43
            ]),
            _createElementVNode("div", {
              class: "rgbatohex__box-block rgbatohex__box-block--text",
              style: _normalizeStyle({ 'box-shadow': '1px 1px 3px 2px ' + _ctx.backgroundColor })
            }, " This div box has shadow with color " + _toDisplayString(_ctx.backgroundColor), 5)
          ])
        ])
      ])
    ])
  ]))
}